import * as angular from 'angular';

const fdCustomButtonFormHtml = require('../../views/fd_custom_button_form.html');

'use strict';

angular.module('formApp').directive('fdCustomButtonForm', function () {
  return {
    templateUrl: fdCustomButtonFormHtml,
    replace: true,
    link: function (scope) {
      var defaultButton = {
        value: '',
        label: '',
        primary: true,
        skipValidation: false
      };

      scope.resetCustomButton = function () {
        scope.models.customButtonForm = { item: angular.copy(defaultButton) };
      };

      scope.addCustomButton = function () {
        if (!scope.models.customButtonForm.item.skipValidation) {
          delete scope.models.customButtonForm.item.skipValidation;
        }
        scope.models.elementCopy.buttons.push(scope.models.customButtonForm.item);
        scope.resetCustomButton();
      };

      scope.editCustomButton = function () {
        const customButtonForm = scope.models.customButtonForm;
        if (!customButtonForm.item.skipValidation) {
          delete customButtonForm.item.skipValidation;
        }
        scope.models.elementCopy.buttons[customButtonForm.indexEdited] = customButtonForm.item;
        scope.resetCustomButton();
      };

      scope.resetCustomButton();
    }
  };
});
